// Hợp nhất nhiều AbortSignal (React Query, timeout, v.v.)
export function mergeAbortSignals(signals: Array<AbortSignal | null | undefined>): AbortSignal {
  const ctrl = new AbortController();
  const onAbort = (ev: Event) => {
    const src = ev.target as AbortSignal;
    // lan truyền reason nếu có (Chrome/Node hỗ trợ)
    // @ts-ignore
    ctrl.abort((src as any).reason);
  };

  for (const s of signals) {
    if (!s) continue;
    if (s.aborted) {
      // @ts-ignore
      ctrl.abort((s as any).reason);
      break;
    }
    s.addEventListener("abort", onAbort, { once: true });
  }
  return ctrl.signal;
}

// Tạo signal tự abort sau ms (nếu bạn cần timeout riêng)
export function timeoutSignal(ms: number, reason?: any): { signal: AbortSignal; cancel: () => void } {
  const ctrl = new AbortController();
  const timer = setTimeout(() => {
    // DOMException('Timeout','TimeoutError') là tuỳ chọn
    ctrl.abort(reason ?? new DOMException("Timeout", "TimeoutError"));
  }, ms);
  return { signal: ctrl.signal, cancel: () => clearTimeout(timer) };
}

// Bọc fetch để tự merge signal truyền vào (tiện cho NSwag client)
export function wrapFetchWithSignal(baseFetch: typeof fetch, extraSignal?: AbortSignal) {
  return (url: string, init?: RequestInit) => {
    const signal = mergeAbortSignals([init?.signal, extraSignal]);
    return baseFetch(url, { ...init, signal });
  };
}
